import type React from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';
const _Blog = (props: React.SVGProps<SVGSVGElement>) => <svg aria-hidden="true" fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props} className={cn('size-4', props.className)} data-sentry-element="svg" data-sentry-component="_Blog" data-sentry-source-file="Blog.tsx">
    <path d="M12.6727 2.01788H3.37874C2.64208 2.01788 2.04541 2.61455 2.04541 3.35122V10.0039C2.04541 10.7406 2.64208 11.3372 3.37874 11.3372H6.31741L8.02008 13.9979L9.69341 11.3372H12.6721C13.4087 11.3372 14.0054 10.7406 14.0054 10.0039V3.35122C14.0054 2.61455 13.4087 2.01788 12.6721 2.01788H12.6727Z" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.33" data-sentry-element="path" data-sentry-source-file="Blog.tsx" />
  </svg>;
const Blog = memo(_Blog);
export const BlogWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="BlogWithIconTag" data-sentry-source-file="Blog.tsx">
    <Blog className={className} data-sentry-element="Blog" data-sentry-source-file="Blog.tsx" />
  </i>;
export default Blog;